import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  ChangeSpAccountStatus,
  GetCurrentUser,
  GetSpAccountStatus,
} from "../utils/api";
import { message } from "antd";
import Loader from "../components/shared/Loader";

let userAgent = navigator.userAgent;
let operatingSystem = "Unknown";

if (userAgent.indexOf("Win") !== -1) {
  operatingSystem = "Windows";
} else if (userAgent.indexOf("Mac") !== -1) {
  operatingSystem = "MacOS";
} else if (userAgent.indexOf("Linux") !== -1) {
  operatingSystem = "Linux";
} else if (userAgent.indexOf("Android") !== -1) {
  operatingSystem = "Android";
} else if (userAgent.indexOf("iOS") !== -1) {
  operatingSystem = "iOS";
}

const Intent =
  operatingSystem === "Windows"
    ? "https://play.google.com/store/apps/details?id=com.app.beautyspotapp"
    : "https://beautyspot.page.link/uy1b";

const Public = () => {
  const { id } = useParams();
  const [spStatus, setSpStatus] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // const fetch = async () => {
    //   try {
    //     const response = await GetCurrentUser(id);
    //     if (response?.data) {
    //       setUser(response?.data);
    //     }
    //     setLoading(false);
    //   } catch (error) {
    //     message.error("Something went wrong. Please try again later");
    //   }
    // };

    const status = async () => {
      try {
        setLoading(true);
        const response = await GetSpAccountStatus({ userId: id });
        if (response) {
          setSpStatus(response?.data);
        }
        // fetch();
        setLoading(false);
      } catch (error) {
        message.error("Something went wrong. Please try again later");
        setLoading(false);
      }
    };
    status();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      {loading ? (
        <Loader />
      ) : spStatus?.isConnected ? (
        <div className="bg-white p-8 rounded shadow-md">
          <h1 className="text-3xl font-bold mb-4">Success!</h1>
          <p className="text-lg mb-4">
            Head back over to the app to complete your profile!
          </p>
          <a
            href={Intent}
            className="block w-max bg-primary-700 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors duration-300"
          >
            Go to app now
          </a>
        </div>
      ) : (
        <div className="bg-white p-8 rounded shadow-md">
          <h1 className="text-3xl font-bold mb-4 ">Reason:</h1>
          <p className="text-lg mb-4">
            {spStatus?.disabledReason || "No specific reason provided."}
          </p>
          <div>
            {spStatus?.errors && spStatus?.errors?.length > 0 && (
              <>
                <strong className="text-red-900">Errors:</strong>
                <ul className="list-disc pl-6">
                  {spStatus.errors.map((err, idx) => (
                    <li className="text-red-500" key={idx}>
                      {err?.message}
                    </li>
                  ))}
                </ul>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Public;
